// src/redux/slices/index.ts
import { combineReducers } from '@reduxjs/toolkit';

// Import your individual reducers here
import gameReducer from './gameSlice';

const rootReducer = combineReducers({
    game: gameReducer,
});

export default rootReducer;
